import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import { DriveOnDisplayableTaskDto as DriveOnTask } from '@/generated/model';
import { useTranslation } from 'react-i18next';
import { TaskChooser } from '@/components/logbook/task/TaskChooser';

import './ChooseTaskDialog.css';

type OtherTasksDialogProps = {
  tasks: DriveOnTask[] | undefined;
  kid: string;
  onClose: () => void;
};

export function OtherTasksDialog({ kid, tasks, onClose }: OtherTasksDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog sx={{ '& .MuiDialog-paper': { height: '80%' } }} open={true}>
      <DialogTitle>
        <Stack direction={'row'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', size: 24 }}>
            "{kid}" {t('menetlevel.choosetask.tasks')}{' '}
          </Typography>
          <IconButton>
            <CloseOutlined onClick={() => onClose()} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Stack className="task-container" spacing={'0.5rem'}>
          {tasks && tasks.length !== 0
            ? tasks.map((t) => (
                <TaskChooser
                  key={t.eventusId}
                  task={t}
                  setTask={(t) => t}
                  enableSelect={false}
                  expanded={undefined}
                  logbook={false}
                />
              ))
            : t('menetlevel.choosetask.noadmintasks')}
        </Stack>
      </DialogContent>
      <DialogActions>
        <ButtonGroup>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            startIcon={<ClearIcon />}
            sx={{ color: 'white', backgroundColor: 'red !important' }}
            style={{ margin: '2px' }}
          >
            {t('general.cancel')}
          </Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
}
